export default __webpack_public_path__ + "static/media/master_card.67be1e20.png";